module.exports = __webpack_public_path__ + "static/img/wechatImg.3e1aa7cb.png";